import React, { useEffect, useRef } from "react";
import { Avatar, Paper, TextField, Typography, Box } from "@mui/material";
import styled from "styled-components/macro";
import { Close } from "@mui/icons-material";

const BigAvatar = styled(Avatar)`
  width: 120px;
  height: 120px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

export default function DocumentUpload({
  documents,
  setDocuments,
  images,
  setImages,
}) {
  const inputFile = useRef(null);
  const onButtonClick = () => {
    inputFile.current.click();
  };

  const handleClose = (i) => (e) => {
    let latest = {};
    let names = {};
    let l = 0;
    // eslint-disable-next-line
    Object.values(images).map((image, ind) => {
      let prev = latest;
      if (parseInt(i) !== parseInt(ind)) {
        let pair = { [l]: image };
        prev = { ...prev, ...pair };
        l++;
      }
      latest = prev;
    });
    setImages(latest);
    l = 0;
    // eslint-disable-next-line
    Object.values(documents).map((name, ind) => {
      let prev = names;
      if (parseInt(i) !== parseInt(ind)) {
        let pair = { [l]: name };
        prev = { ...prev, ...pair };
        l++;
      }
      names = prev;
    });
    setDocuments(names);
  };

  const fileSelectedHandler = (e) => {
    let prev = images;
    let names = documents;
    let l = Object.keys(images).length;
    // eslint-disable-next-line
    Object.values(e.target.files).map((file) => {
      let pair = { [l]: file };
      let namePair = { [l]: file.name.split(".").slice(0, -1).join(".") };
      prev = { ...prev, ...pair };
      names = { ...names, ...namePair };
      l++;
    });
    setImages(prev);
    setDocuments(names);
    e.target.value = null;
  };
  useEffect(() => {
    
  }, [images]);
  const nameHandler = (i) => (e) => {
    let names = documents;
    let pair = { [i]: e.target.value };
    names = { ...names, ...pair };
    setDocuments(names);
    // formData.set(`document_${i}_name`, e.target.value);
  };
  useEffect(() => {
  }, [documents]);

  return (
    <Paper mt={3} m={2}>
      <Typography component="h1" variant="h4" align="center" gutterBottom>
        Click Below to Upload documents
      </Typography>
      <BigAvatar
        style={{ cursor: "pointer" }}
        onClick={onButtonClick}
        src="/static/img/images/upload.png"
      />
      <input
        type="file"
        id="file"
        multiple
        ref={inputFile}
        accept=".png, .jpg, .jpeg, .pdf"
        onChange={fileSelectedHandler}
        style={{ display: "none" }}
      />
      {Object.values(images).map((image, i) => {
        return (
          <Paper
            key={i}
            style={{ display: "flex", alignItems: "center" }}
            mt={3}
            m={2}
          >
            <Box
              m={2}
              component="img"
              width="80px"
              height="80px"
              onClick={() => window.open(URL.createObjectURL(image))}
              src={
                image?.type === "image/png" ||
                image?.type === "image/jpg" ||
                image?.type === "image/jpeg"
                  ? "/static/img/images/image.png"
                  : "/static/img/images/pdf.png"
              }
            />
            <div></div>
            <TextField
              autoFocus
              fullWidth
              margin="dense"
              m={2}
              value={documents[i]}
              id="standard-required"
              label="Document Name"
              onChange={nameHandler(i)}
            />
            <Close
              style={{ marginLeft: 8, cursor: "pointer" }}
              onClick={handleClose(i)}
            />
          </Paper>
        );
      })}
    </Paper>
  );
}
